var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.currentComponent,{tag:"component",attrs:{"batch-operation-record-info":_vm.info},on:{"schedule-updated":_vm.fetchData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }